/**
 * Normalizes whitespace in strings.
 *
 * Removes leading/trailing whitespace and collapses multiple spaces to single space.
 */
export function trimWhitespace(value: string): string {
  value = value.trim(); // remove leading and trailing whitespaces
  value = value.replace(/\s{2,}/g, ' '); // remove multiple whitespaces in between
  return value;
}
